(() => {
  const dropdown = document.querySelector('[data-faq-dropdown]');
  const content = document.querySelector('[data-faq-content]');
  if (!content) return;

  const details = Array.from(content.querySelectorAll('details[data-faq-group]'));
  const headings = Array.from(content.querySelectorAll('h2[data-faq-group]'));

  // Si hay filtro de categoria, selectIndex se rellena mas abajo. Sin
  // filtro (una sola categoria), se queda en null y openFromHash no
  // necesita cambiar ninguna categoria — todas las preguntas ya estan
  // visibles.
  let selectIndex = null;

  // Selecciona la categoria que coincida con el hash de la URL (ej.
  // /pages/faq#refunds) y desplaza hasta su primera pregunta — enlace
  // directo a una categoria entera desde fuera de la pagina (emails,
  // otras paginas, etc). El <h2> de la categoria no sirve como destino
  // del scroll porque queda oculto cuando hay filtro (ver .liquid).
  const openFromHash = () => {
    if (!location.hash) return;
    const id = decodeURIComponent(location.hash.slice(1));
    const heading = headings.find((item) => item.id === id);
    if (!heading) return;
    const index = heading.dataset.faqGroup;
    if (selectIndex) selectIndex(Number(index));
    const firstQuestion = details.find((item) => item.dataset.faqGroup === index);
    if (firstQuestion) firstQuestion.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (dropdown) {
    const toggle = dropdown.querySelector('[data-faq-dropdown-toggle]');
    const panel = dropdown.querySelector('[data-faq-dropdown-panel]');
    const scrim = dropdown.querySelector('[data-faq-dropdown-scrim]');
    const valueEl = dropdown.querySelector('[data-faq-dropdown-value]');
    const options = Array.from(dropdown.querySelectorAll('[data-faq-dropdown-option]'));

    if (toggle && panel && valueEl && options.length) {
      const openPanel = () => {
        panel.hidden = false;
        if (scrim) scrim.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      };

      const closePanel = () => {
        panel.hidden = true;
        if (scrim) scrim.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      };

      selectIndex = (index) => {
        options.forEach((option) => {
          const isSelected = option.dataset.faqCategoryIndex === String(index);
          option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          if (isSelected) valueEl.textContent = option.textContent.trim();
        });
        details.forEach((item) => {
          item.hidden = item.dataset.faqGroup !== String(index);
          if (item.hidden) item.open = false;
        });
      };

      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closePanel();
        } else {
          openPanel();
        }
      });

      options.forEach((option) => {
        option.addEventListener('click', () => {
          selectIndex(Number(option.dataset.faqCategoryIndex));
          closePanel();
          toggle.focus();
        });
      });

      if (scrim) {
        scrim.addEventListener('click', closePanel);
      }

      document.addEventListener('click', (event) => {
        if (event.target === scrim) return;
        if (!dropdown.contains(event.target)) closePanel();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePanel();
      });

      const initiallySelected = options.find((option) => option.getAttribute('aria-selected') === 'true') || options[0];
      if (initiallySelected) valueEl.textContent = initiallySelected.textContent.trim();
    }
  }

  openFromHash();

  // Si ya estas en /pages/faq y clicas un enlace a OTRA categoria de la
  // misma pagina (ej. desde el footer), el navegador no recarga —
  // solo cambia la URL y dispara hashchange, sin volver a ejecutar este
  // script. Sin este listener, la categoria se quedaba como estaba.
  window.addEventListener('hashchange', openFromHash);
})();
